export enum AppEventTypeEnum {
  PACADATAREFRESH,
}
